import React from 'react'

import cn from '../../libs/class-names'

export interface Props {
  classNames?: string[]
  label: string
  icon?: React.ReactNode
  type?:
    | 'base'
    | 'brand'
    | 'error'
    | 'success'
    | 'warning'
    | 'warning-alternative'
    | 'cyan'
    | 'pink'
    | 'purple'
    | 'gold'
  size?: 'default' | 's' | 'xs'
  appearance?: 'base' | 'alternative'
}

const Badge = ({
  classNames,
  label,
  icon,
  type = 'base',
  size = 'default',
  appearance = 'base',
}: Props) => (
  <span
    className={cn(
      'Badge',
      {[`type-${type}`]: !!type, [`size-${size}`]: true, [`appearance-${appearance}`]: true},
      classNames
    )}
  >
    {appearance === 'base' && icon}
    {label}
  </span>
)

export default Badge
